import React from 'react';
import { css } from 'emotion';
import { palette, space } from '@guardian/src-foundations';
import { body } from '@guardian/src-foundations/typography';
import { SvgAlertRound } from '@guardian/src-icons';
import { Caption } from '@root/src/web/components/Caption';
import { YoutubeAtom } from '@guardian/atoms-rendering';
const expiredOverlayStyles = (overrideImage) => css `
    height: 0px;
    position: relative;
    background-image: url(${overrideImage});
    background-size: cover;
    background-position: 49% 49%;
    background-repeat: no-repeat;
    padding-bottom: 56%;
    color: ${palette.neutral[100]};
    background-color: ${palette.neutral[20]};
`;
const expiredTextWrapperStyles = css `
    display: flex;
    flex-direction: row;
    align-items: center;

    padding-top: ${space[4]}px;
    padding-bottom: ${space[4]}px;
    padding-left: ${space[1]}px;
    padding-right: ${space[12]}px;
    color: ${palette.neutral[100]};
    background-color: ${palette.neutral[20]};
`;
const expiredSVGWrapperStyles = css `
    padding-right: ${space[1]}px;
    svg {
        width: ${space[12]}px;
        height: ${space[12]}px;
        fill: ${palette.neutral[100]};
    }
`;
export const YoutubeBlockComponent = ({ display, designType, element, pillar, hideCaption, overlayImage, role, adTargeting, isMainMedia, height = 259, width = 460, title = 'YouTube video player', duration, }) => {
    const shouldLimitWidth = !isMainMedia &&
        (role === 'showcase' || role === 'supporting' || role === 'immersive');
    if (element.expired) {
        return (React.createElement("figure", { className: css `
                    margin-top: 16px;
                    margin-bottom: 16px;
                ` },
            React.createElement("div", { className: expiredOverlayStyles(element.overrideImage) },
                React.createElement("div", { className: expiredTextWrapperStyles },
                    React.createElement("div", { className: expiredSVGWrapperStyles },
                        React.createElement(SvgAlertRound, null)),
                    React.createElement("p", { className: css `
                                ${body.medium({
                            lineHeight: 'tight',
                        })}
                            ` }, "This video has been removed. This could be because it launched early, our rights have expired, there was a legal issue, or for another reason."))),
            !hideCaption && (React.createElement(Caption, { display: display, designType: designType, captionText: element.mediaTitle || '', pillar: pillar, displayCredit: false, shouldLimitWidth: shouldLimitWidth }))));
    }
    return (React.createElement("div", { "data-chromatic": "ignore" },
        React.createElement(YoutubeAtom, { videoMeta: element, overlayImage: overlayImage, adTargeting: adTargeting, height: height, width: width, title: title, duration: duration }),
        !hideCaption && (React.createElement(Caption, { display: display, designType: designType, captionText: element.mediaTitle || '', pillar: pillar, displayCredit: false, shouldLimitWidth: shouldLimitWidth }))));
};
